import RecentUpdates from './RecentUpdates';
export default RecentUpdates;
